import { storage } from '../services/StorageService';

// Clear storage without clearing training video acknowledgement
export const clearStorage = () => {
  storage.clearSession();
};
